const meta = {
  panels: 'Panels',
  customization: 'Customize',
  'query-traces': 'Query traces',
  'chronosphere-managed-dashboards': 'Chronosphere-managed dashboards',
  'classic-dashboards': 'Classic dashboards',
  endpoint_schema: {
    title: 'Standard dashboard config reference',
    href: '/tooling/api-info/dashboard_schema',
    newWindow: true,
  },
};

export default meta;
